import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import TermLengths from './FullUWCoverageLengths';
import AboutData from './AboutData';
import ProductSpecificationsData from './ProductSpecificationsData';
import MarketingData from './MarketingData';
import PurchasingProcessData from './PurchasingProcessData';
import FaqData from './FaqData';
import PreQuote from '../../../../Quoters/PreQuote/PreQuote';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../../../sessionStorage';
import AboutMeForm from '../../../../Quoters/MCT/steps/AboutMeForm';
import { getPrimaryColor } from '../../../../Quoters/Common/Helpers/Utility';

export default function TermData(props) {
  const primaryBrandColor = getPrimaryColor();

  const minAge = 18;
  const maxAge = 70;
  const minCoverageAmount = 100000;
  const maxCoverageAmount = 10000000;

  const navigate = useNavigate();
  const location = useLocation();

  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  
  var accountProductTypeSettings = props ? accountObj.accountProducts.find(product => product.productLandingUrl === location.pathname) : null;
  var accountLandingOverride = accountObj.accountOverrides && accountProductTypeSettings ? 
    accountObj.accountOverrides.find(override => override.accountProductTypeId === accountProductTypeSettings.productTypeId) : null;

  const mctForm = <AboutMeForm
    ageSpecs={{min: minAge, max: maxAge}}
    onNext={() => {
      navigate('/quote/term-life-insurance/multi-carrier-term/pre-quote');
    }}
    brandTheme={primaryBrandColor}
    showHeader={false}
    submitButtonVariant={'landing'}
  />

  const defaultValueProposition = [{
    title: "Term Life Insurance",
    subtitle: "Click. Quote. Coverage.",
    subtitleExtended: ""
  }]

  return {
    name: 'Term Life Insurance',
    subtitle: 'Click. Quote. Coverage.',
    footerMessage: "Get term insurance from start to finish completely online.",
    heroText: accountLandingOverride ? JSON.parse(accountLandingOverride.valueProposition) : defaultValueProposition,
    specs: {
      age: {min: minAge, max: maxAge},
      coverageAmount: {min: minCoverageAmount, max: maxCoverageAmount},
    },
    basicInfoForm: () => {
      return mctForm;
    },
    about: AboutData(),
    productSpecifications: ProductSpecificationsData(minAge, maxAge, minCoverageAmount, maxCoverageAmount, TermLengths()),
    marketing: MarketingData(),
    purchasingProcess: PurchasingProcessData(),
    articleKeys: [1, 2, 3],
    faq: FaqData()
  }
}
 